module.exports = __webpack_public_path__ + "img/Tutorial_QuantitativeDeskriptor.5fe267ea.jpg";